/** Import react/libraries section **/
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';

/** Import helpers section **/
import {
  addUserService,
  updateUserService,
  changePasswordService
} from '../../../api/services/users-services';

import { isValidEmail } from '../../../utils/validations';

/** Import component section **/
import UserModalView from './UserModalView';

const UserModalComponent = ({
  userData,
  modalMode,
  roles,
  onClose,
  onUpdateList
}) => {
  const [user, setUser] = useState(null);
  const [dataComplete, setDataComplete] = useState(null);

  useEffect(() => {
    const newUSer = Object.assign(
      { password: null, password_conf: null },
      userData
    );
    setUser(newUSer);
  }, [userData]);

  const onInputChange = (data, field) => {
  const {name,value} = data;
    setUser((prevState) => ({
      ...prevState,
      [name]: value
    }));
  };

  const onSwitchChange = (event) => {
    let value = event.target.checked === false ? 0 : 1;
    setUser((prevState) => ({
      ...prevState,
      active: value
    }));
  };

  useEffect(() => {
    if (!user) return;
    let validated = true;
    if (modalMode === 'user') {
      const email = user?.email?.trim();
      const first_name = user?.first_name?.trim();
      const last_name = user?.last_name?.trim();
      const role_id = user?.role_id;
      if (first_name === '' || last_name ==='' || !role_id || !isValidEmail(email)) {
        validated = false;
      }
    }

    if (modalMode === 'password' || !user?.id) {
      if (user?.password && user?.password_conf) {
        const password = user?.password.trim();
        const password_conf = user?.password_conf.trim();
        if (
          password === '' ||
          password_conf === '' ||
          password !== password_conf
        ) {
          validated = false;
        }
      } else {
        validated = false;
      }
    }
    setDataComplete(validated);
  }, [user, modalMode]);

  const handleOnSave = () => {
    if (modalMode === 'password') {
      changePassword();
    } else if (user.id) {
      updateUser();
    } else {
      createUser();
    }
  };

  const createUser = () => {
    addUserService(user)
      .then((response) => {
        toast('User created', { type: 'success' });
        onUpdateList();
        onClose();
      })
      .catch((error) => {
        toast('User create error', { type: 'warning' });
      });
  };

  const updateUser = () => {
    updateUserService(user)
      .then(() => {
        toast('User updated', { type: 'success' });
        onUpdateList();
        onClose();
      })
      .catch((error) => {
        toast('User update error', { type: 'warning' });
      });
  };

  const changePassword = () => {
    changePasswordService(user)
      .then(() => {
        toast('User updated', { type: 'success' });
        onUpdateList();
        onClose();
      })
      .catch((error) => {
        toast('User update error', { type: 'warning' });
      });
  };

  return (
    <UserModalView
      user={user}
      modalMode={modalMode}
      roles={roles}
      onInputChange={onInputChange}
      onSwitchChange={onSwitchChange}
      onClose={onClose}
      onSave={handleOnSave}
      disabled={!dataComplete}
    />
  );
};

export default UserModalComponent;
